import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'pulse-loading-screen',
  standalone: true,
  templateUrl: './pulse-loading-screen.component.html',
  styleUrl: './pulse-loading-screen.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class PulseLoadingScreenComponent {}
